import 'hammerjs'
import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { AppModule } from './app/app.module'
import { environment } from './environments/environment'
// import { AllEnterpriseModule, LicenseManager, ModuleRegistry } from 'ag-grid-enterprise';

// import { AgChartsCommunityModule } from 'ag-charts-community';
// ModuleRegistry.registerModules([AllEnterpriseModule.with(AgChartsCommunityModule)]);
import { ModuleRegistry, provideGlobalGridOptions } from 'ag-grid-community'
import {
  AllEnterpriseModule,
  LicenseManager,
  ColumnMenuModule,
  ContextMenuModule,
  ServerSideRowModelModule,
  MenuModule,
  ColumnsToolPanelModule,
  ClientSideRowModelApiModule,
  SetFilterModule
} from 'ag-grid-enterprise'

// Mark all grids as using legacy themes
provideGlobalGridOptions({ theme: 'legacy' })

LicenseManager.setLicenseKey(
  'Using_this_{AG_Grid}_Enterprise_key_{AG-098925}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Quantworks,_Inc.}_is_granted_a_{Multiple_Applications}_Developer_License_for_{2}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{8}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{17_May_2027}____[v3]_[01]_MTgxMDUwODQwMDAwMA==a517952595c32ffdd96b9ac9fd78b04d'
)

// Register all enterprise features
ModuleRegistry.registerModules([
  AllEnterpriseModule,
  ColumnMenuModule,
  ContextMenuModule,
  MenuModule,
  ColumnsToolPanelModule,
  ServerSideRowModelModule,
  ClientSideRowModelApiModule,
  SetFilterModule
])

if (environment.production) {
  enableProdMode()
  // Once the environment is production the code below will disable the all logs across the app
  if (window) {
    window.console.log = function () {}
    window.console.warn = function () {}
    window.console.error = function () {}
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err))
